import { createSlice } from '@reduxjs/toolkit';

const initialModalState = {
	active: [],
};

const modalSlice = createSlice({
	name: 'modals',
	initialState: initialModalState,
	reducers: {
		setShowModal: (state, action) => {
			const { type, show = true, payload, params = null } = action.payload;

			if (show) {
				state.active.push({ type, show, payload, params });
				return;
			}

			const filteredModals = state.active.filter((modal) => modal.type !== type);
			state.active = filteredModals;
		},
		updateModalPayload: (state, action) => {
			const { type, payload } = action.payload;
			const modalIndex = state.active.findIndex((modal) => modal.type === type);

			if (modalIndex !== -1) {
				state.active[modalIndex].payload = payload;
			}
		},
	},
});

const selectModal = (state, modalType) => {
	const selectedModal = state.modals.active.find((modal) => modal.type === modalType);

	const modal = {
		show: selectedModal ? selectedModal.show : false,
		payload: selectedModal ? selectedModal?.payload : null,
		params: selectedModal ? selectedModal?.params : null,
	};
	return modal;
};
const areModalsActive = (state) => state.modals.active.length > 0;
const activeModals = (state) => state.modals.active;

const { setShowModal, updateModalPayload } = modalSlice.actions;

export { activeModals, areModalsActive, selectModal, setShowModal, updateModalPayload };

export default modalSlice.reducer;
